import DescriptionDetail from "src/shared/components/data-display/description-detail/DescriptionDetail"
import Drawer from "src/shared/components/layout/drawer/Drawer"
import { formatCurrencyToFixed } from "src/shared/hooks/formatCurrency"
import { formatText } from "src/shared/hooks/formatTextOpcions"
import { sum } from "src/shared/helpers/calculator"
import { HuespedesDetailProps } from "./HuespedesDetail.type"
import "./HuespedesDetail.css"

const emptyValue = "-"

const HuespedesDetail = ({ isOpen, onClose, data }: HuespedesDetailProps): JSX.Element => {
    // matrícula y color sólo aplican cuando el huésped entró en auto
    const isAuto = data?.tipo_entrada?.toLowerCase() === "auto"

    const total = formatCurrencyToFixed(
        sum([
            data?.consumo_renta || 0,
            data?.consumo_reserva || 0,
            data?.consumo_extras || 0,
            data?.consumo_restaurante || 0,
            data?.consumo_room_service || 0,
        ])
    )

    return (
        <Drawer placement={"right"} bar={false} visible={isOpen} withCloseButton onClose={onClose} testId="huespedes-detail">
            <div className="huespedes-detail__head">
                <p className="huespedes-detail__title">Entrada de huésped</p>
                {!!data?.huesped && <p className="huespedes-detail__subtitle">{data.huesped}</p>}
            </div>
            <div className="huespedes-detail__body">
                <div className="huespedes-detail__description">
                    <DescriptionDetail
                        icon={"FileListFill"}
                        label={"Entrada"}
                        value={data?.tipo_entrada ? formatText(data.tipo_entrada) : emptyValue}
                    />
                    <DescriptionDetail
                        icon={"car"}
                        label={"Matrícula"}
                        value={(isAuto && data?.matricula_vehiculo) || emptyValue}
                    />
                    <DescriptionDetail
                        icon={"Palette"}
                        label={"Color"}
                        value={(isAuto && data?.color_vehiculo) || emptyValue}
                    />
                    <DescriptionDetail
                        className={"huespedes-detail__value--full"}
                        icon={"giftFill"}
                        label={"Easyrewards"}
                        value={data?.easyrewards || emptyValue}
                    />
                    <DescriptionDetail
                        icon={"BedFilled"}
                        label={"Total renta"}
                        value={formatCurrencyToFixed(data?.consumo_renta || 0)}
                    />
                    <DescriptionDetail
                        icon={"calendarFill"}
                        label={"Total reserva"}
                        value={formatCurrencyToFixed(data?.consumo_reserva || 0)}
                    />
                    <DescriptionDetail
                        icon={"dollarCircle"}
                        label={"Total extras"}
                        value={formatCurrencyToFixed(data?.consumo_extras || 0)}
                    />
                    <DescriptionDetail
                        icon={"restaurantFill"}
                        label={"Total restaurante"}
                        value={formatCurrencyToFixed(data?.consumo_restaurante || 0)}
                    />
                    <DescriptionDetail
                        icon={"Order"}
                        label={"Total room service"}
                        value={formatCurrencyToFixed(data?.consumo_room_service || 0)}
                    />
                    <DescriptionDetail
                        icon={"handCoin"}
                        label={"Total propinas"}
                        value={formatCurrencyToFixed(data?.consumo_propinas || 0)}
                    />
                    <DescriptionDetail
                        className={"huespedes-detail__value--full"}
                        icon={"dollarCircle"}
                        label={"Total"}
                        value={total}
                    />
                </div>
            </div>
        </Drawer>
    )
}

export default HuespedesDetail
